module.exports = __webpack_public_path__ + "img/g3-en.1498bdb6.jpeg";